import React from 'react';
import { useState,useEffect } from 'react';

export default function ZynthStats() {
    const [stats,setStats]=useState({
        'presentations':1134,
        'slides':9560
    })
    useEffect(()=>{
        const fetchData = async () => {
      try {
        const res = await fetch(`${process.env.REACT_APP_BACKEND_URL}/api/v1/data/appscripts/getStatistics`);
        const json = await res.json();
        setStats(json);
      } catch (error) {
        console.error("Error fetching data:", error);
      } 
    };
      fetchData();
    },[])

  return (
      <section className="w-full bg-white py-12 px-6 sm:px-6">
    <div className="max-w-7xl mx-auto flex flex-col md:flex-row md:flex-wrap gap-6 md:gap-10 items-stretch justify-between px-2">
      
        <div className="flex-1 flex flex-col justify-center">
          <h2 className="text-2xl sm:text-3xl md:text-4xl font-bold mb-4 leading-tight">
            Zynth In Past 7 Days 
            {/* <br className="hidden sm:block" />
            <span className="font-semibold">(Past 7 Days)</span> */}
          </h2>
          <p className="text-gray-600 text-sm sm:text-base leading-relaxed font-semibold">
            Join the creators using Zynth as their go-to AI presentation maker, PPT generator, and pitch deck tool. <br />
            
          </p>
        </div>

     
   <div className="flex-1 flex flex-col sm:flex-row justify-center md:justify-end items-center gap-4">
  <div className="flex flex-col items-center justify-center border rounded-xl px-3 py-8 text-center shadow-sm w-full sm:w-[250px] h-full">
    <h3 className="text-2xl font-bold">{stats.presentations}</h3>
    <p className="text-gray-600 text-xl mt-1 text-center font-semibold">Presentations Generated</p>
  </div>

  <div className="flex flex-col items-center justify-center border rounded-xl px-6 py-8 text-center shadow-sm w-full sm:w-[250px] h-full">
    <h3 className="text-2xl font-bold">{stats.slides}</h3>
    <p className="text-gray-600 text-xl mt-1 text-center font-semibold">Slides Created with AI</p>
  </div>
</div>

      </div>
    </section>
  );
}
